
import React from 'react'

export const COLUMNS = [
  {
    name: 'silo',
    label: 'Silo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'sector',
    label: 'Sector',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'metrosDeVacio',
    label: 'Mtrs Vacio',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Capacidad B. Trigo [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Capacidad B. Vigente [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia Vigente [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacio',
    label: 'Espacio Total [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_TOTALES = [
  {
    name: 'sector',
    label: 'Sector',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'metrosDeVacioTotal',
    label: 'Mtrs Vacio',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Capacidad Base Trigo [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => parseFloat(value).toFixed(2)
    }
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Capacidad Base Vigente [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => parseFloat(value).toFixed(2)
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia Vigente [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => parseFloat(value).toFixed(2)
    }
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio Total [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => parseFloat(value).toFixed(2)
    }
  },
  {
    name: 'espacioTotalCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => parseFloat(value).toFixed(0)
    }
  }
]
